module.exports = __webpack_public_path__ + "static/media/reyna.954dbdeb.png";